<template>
    <div class="driver-pick-up">
        <PickUpToggle v-model="state"
                      @toggle="onToggle"
                      :disabled="disabled"
                      :labels="{checked: 'Loaded', unchecked: 'Load'}"/>

        <ConfirmPickUp v-model="showPickUpConfirm"
                       :carItineraryHelper="carItineraryHelper"
                       :accessType="accessType"
                       :encryptedData="encryptedData"
                       @cancel="updateState(false)"
                       @changeForbidden="disabled=true"
                       @error="updateState(false)"></ConfirmPickUp>

        <ConfirmUnpickUp v-model="showUnpickUpConfirm"
                         :carItineraryHelper="carItineraryHelper"
                         :accessType="accessType"
                         :encryptedData="encryptedData"
                         @confirm="updateState(false)"
                         @cancel="updateState(true)"
                         @changeForbidden="changeForbidden"
                         @error="updateState(true)"></ConfirmUnpickUp>
    </div>
</template>

<script>

import AccessType from '@/components/Core/AccessType'
import moment from 'moment'
import PickUpToggle from '@/components/Core/Input/Toggle'
import ConfirmPickUp from '@/components/CarItinerary/PickUp/PickUpToggle/ConfirmPickUp'
import ConfirmUnpickUp from '@/components/CarItinerary/PickUp/PickUpToggle/ConfirmUnpickUp'

export default {
  extends: AccessType,
  components: {
    PickUpToggle, ConfirmPickUp, ConfirmUnpickUp
  },
  created () {
    this.updateDisabled()
  },
  props: {
    carItineraryHelper: {
      type: Object,
      required: true
    }
  },
  name: 'DriverPickUp',
  data () {
    return {
      showPickUpConfirm: false,
      showUnpickUpConfirm: false,
      state: this.carItineraryHelper.isPickedUp(),
      disabled: false
    }
  },
  methods: {
    updateState (state) {
      this.state = state
    },
    onToggle (e) {
      if (e.value) {
        this.showPickUpConfirm = true
      } else {
        this.showUnpickUpConfirm = true
      }
    },
    changeForbidden () {
      this.updateState(true)
      this.disabled = true
    },
    allowCancellingPickUp () {
      return !this.carItineraryHelper.isPickedUp() || (!this.carItineraryHelper.isUnloaded() && this.carItineraryHelper.isPickedUp() && moment(this.carItineraryHelper.getCarItinerary().pickUpDate) > moment().subtract(2, 'days'))
    },
    updateDisabled () {
      this.disabled = !this.allowCancellingPickUp()
    }
  },
  watch: {
    carItineraryHelper: function () {
      this.updateDisabled()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
